import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["sx"];
import PropTypes from 'prop-types';
import * as React from 'react';
import MuiAppBar from '@mui/material/AppBar';
import { extendSX } from '../helpers';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [App bar](https://ui-packages.isbuildingluma.com/ui-core/react-app-bar/)
 *
 * API:
 *
 * - [AppBar API](https://ui-packages.isbuildingluma.com/ui-core/api/app-bar/)
 * - inherits [MuiAppBar API](https://mui.com/material-ui/api/app-bar/)
 */
const AppBar = /*#__PURE__*/React.forwardRef(function AppBar(_ref, ref) {
  let {
      sx
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(MuiAppBar, _extends({
    sx: extendSX(sx),
    ref: ref
  }, rest));
});
process.env.NODE_ENV !== "production" ? AppBar.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit "AppBarProps.ts" and run "yarn proptypes"
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export default AppBar;